import { render, staticRenderFns } from "./CategoriesModules.vue?vue&type=template&id=fc68e97a&scoped=true&"
import script from "./CategoriesModules.vue?vue&type=script&lang=js&"
export * from "./CategoriesModules.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesModules.vue?vue&type=style&index=0&id=fc68e97a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc68e97a",
  null
  
)

component.options.__file = "CategoriesModules.vue"
export default component.exports